import { render, staticRenderFns } from "./DataFieldV.vue?vue&type=template&id=09ae1c05"
import script from "./DataFieldV.vue?vue&type=script&lang=js"
export * from "./DataFieldV.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports